<sfz-menu #menu>
  <div jhiMoveToSlot slotName="menu" [parentElement]="menu">
    <ng-container *ngFor="let item of menuLista">
      <sfz-menu-tab
        slot="menu"
        style="min-height: 70px; color: #000"
        [attr.title]="item.titulo"
        [attr.icon]="item.icone"
        [attr.href]="montarLink(item.link, item.externo)"
        [attr.submenus]="montarSubmenus(item.submenus, item.externo)"
      >
      </sfz-menu-tab>
    </ng-container>
  </div>
</sfz-menu>
